module.exports = __webpack_public_path__ + "static/media/features-split-image-03.204b1f30.png";